<template>
    <div id="home-page">
        <div class="loginBg">
            <el-carousel trigger="click" height="20vw" arrow="never">
                <el-carousel-item v-for="item in imgList" :key="item.pictureUrl">
                    <router-link :to="'/game/detail/' + item.id" class="info">
                        <img :src="item.pictureUrl" alt="">
                    </router-link>

                    <!--<router-link :to="''">-->
                        <!--<img :src="item.pictureUrl" alt="">-->
                    <!--</router-link>-->
                </el-carousel-item>
            </el-carousel>
            <div class="loginCenter" v-if="!showLogin">
                <div class="loginArea"></div>
                <!--<el-form v-if="showLogin" label-width="0" :model="loginData" :rules="loginRules" ref="loginForm">-->
                <!--<h3>{{contents[875]}}</h3>-->
                <!--<el-form-item label="" prop="loginName">-->
                <!--<el-input placeholder="请输入账号" v-model.trim="loginData.loginName"-->
                <!--@keyup.enter.native="login('loginForm')">-->
                <!--</el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="" prop="pwd">-->
                <!--<el-input type="password" v-model.trim="loginData.pwd" placeholder="请输入密码"-->
                <!--@keyup.enter.native="login('loginForm')">-->
                <!--</el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="" prop="">-->
                <!--&lt;!&ndash;<el-checkbox v-model="rememberPassword">记住密码</el-checkbox>-->
                <!--<router-link style="float: right" :to="'/forgot_password'" class="el-button&#45;&#45;text">忘记密码？</router-link>&ndash;&gt;-->
                <!--</el-form-item>-->
                <!--<el-form-item label="" prop="">-->
                <!--<el-button style="width: 100%" type="primary" @click="login('loginForm')">{{contents[876]}}</el-button>-->
                <!--<p>-->
                <!--<span>{{contents[877]}}</span>-->
                <!--<router-link style="float: right" :to="'/register'" class="el-button&#45;&#45;text">{{contents[878]}}-->

                <!--</router-link>-->
                <!--</p>-->
                <!--</el-form-item>-->
                <!--</el-form>-->

                <!--登录成功后-->
                <div v-if="!showLogin" class="user">
                    <div style="overflow: hidden">
                        <div class="userLogo">
                            <router-link :to="'/user/1-1'">
                                <img :src="headerimg">
                            </router-link>
                        </div>
                        <div style="float: left;padding: 30px 0 0 10px">
                            <p>
                                <router-link :to="'/user/1-1'">{{contents[879]}} {{account}}</router-link>
                            </p>
                            <p>
                                <el-button style="color: #333" type="text" @click="loginOut()">{{contents[880]}}
                                </el-button>
                            </p>
                        </div>
                    </div>
                    <div class="user-bottom">
                        <router-link :to="'/user/1-1'">{{contents[881]}}</router-link>
                        <router-link :to="'/user/1-3'">{{contents[882]}}</router-link>
                        <router-link :to="'/user/1-4'">{{contents[883]}}</router-link>
                    </div>
                    <div>
                        <h4>{{contents[884]}}</h4>
                        <p>{{contents[885]}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="content">
            <!--<div class="part part1">-->
            <!--<div class="part-title">-->
            <!--<h3>{{contents[886]}}</h3>-->
            <!--<span class="pull-right" style="margin-right: 10px">-->
            <!--<router-link :to="'/game'" class="el-button&#45;&#45;text">{{contents[887]}}</router-link>-->
            <!--</span>-->
            <!--</div>-->
            <!--<div class="part-body" style="height: 190px">-->
            <!--<div style="cursor: pointer" @click="toGame()"><img src="../../assets/img/tjt.png" alt=""></div>-->
            <!--</div>-->
            <!--</div>-->
            <div class="part part2">
                <div class="part2-left fl">
                    <!--<div class="part-title">-->
                        <!--<h3>热门攻略</h3>-->
                        <!--<span class="pull-right" style="margin-right: 10px">-->
                    <!--</span>-->
                    <!--</div>-->
                    <!--<div class="part-body">-->
                        <!--<el-table-->
                            <!--:data="tableData4"-->
                            <!--:show-header="false"-->
                            <!--style="width: 100%">-->
                            <!--<el-table-column>-->
                                <!--<template slot-scope="scope">-->
                                    <!--<router-link-->
                                        <!--style="width: 100%;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"-->
                                        <!--:to=" '/introduction/' + scope.row.id">{{scope.row.text}}-->
                                    <!--</router-link>-->
                                <!--</template>-->
                            <!--</el-table-column>-->
                        <!--</el-table>-->
                    <!--</div>-->
                    <div class="part">
                        <div class="part-title">
                            <h3>热门攻略</h3>
                            <span class="pull-right" style="margin-right: 10px">
                    <!--<router-link target="_blank" :to="'/introduction'" class="el-button&#45;&#45;text">{{contents[889]}}</router-link>-->
                    </span>
                        </div>
                        <div class="part-body">
                            <div class="game-list">
                                <!--<div class="game-item" style="cursor: pointer" @click="toGame()">-->
                                <!--<img src="../../assets/img/game1.png" alt="">-->
                                <!--</div>-->
                                <!--<div class="game-item" style="cursor: pointer" @click="toGame()">-->
                                <!--<img src="../../assets/img/game2.png" alt="">-->
                                <!--</div>-->

                                <div class="game-item" style="cursor: pointer">
                                    <router-link :to="'/introduction/1'"><img src="../../assets/img/introduction/1.png"
                                                                             alt=""></router-link>
                                </div>
                                <div class="game-item" style="cursor: pointer">
                                    <router-link :to="'/introduction/2'"><img src="../../assets/img/introduction/2.png"
                                                                             alt=""></router-link>
                                </div>
                                <div class="game-item" style="cursor: pointer">
                                    <router-link :to="'/introduction/3'"><img src="../../assets/img/introduction/5.png"
                                                                             alt=""></router-link>
                                </div>
                            </div>
                            <div class="game-list">
                                <div class="game-item" style="cursor: pointer">
                                    <router-link :to="'/introduction/4'"><img src="../../assets/img/introduction/6.png"
                                                                             alt=""></router-link>
                                </div>
                                <div class="game-item" style="cursor: pointer">
                                    <router-link :to="'/introduction/5'"><img src="../../assets/img/introduction/7.png"
                                                                             alt=""></router-link>
                                </div>
                                <div class="game-item" style="cursor: pointer">
                                    <router-link :to="'/introduction/6'"><img src="../../assets/img/introduction/8.png"
                                                                             alt=""></router-link>
                                </div>
                            </div>
                            <!--<div class="game-list">-->
                                <!--<div class="game-item" style="cursor: pointer">-->
                                    <!--<router-link :to="'/introduction/7'"><img src="../../assets/img/introduction/7.png"-->
                                                                              <!--alt=""></router-link>-->
                                <!--</div>-->
                                <!--<div class="game-item" style="cursor: pointer">-->
                                    <!--<router-link :to="'/introduction/8'"><img src="../../assets/img/introduction/8.png"-->
                                                                              <!--alt=""></router-link>-->
                                <!--</div>-->
                            <!--</div>-->
                        </div>
                    </div>
                    <div class="part">
                        <div class="part-title">
                            <h3>宣传视频</h3>
                            <span class="pull-right" style="margin-right: 10px">
                    </span>
                        </div>
                        <div class="part-body">
                            <div class="game-list">
                                <div class="game-item" style="cursor: pointer">
                                    <video src="../../assets/MV2.mp4" controls></video>

                                    <div>超进化物语2MV</div>
                                </div>

                                <div class="game-item" style="cursor: pointer">
                                    <video src="../../assets/cjhwy.mp4" controls></video>

                                    <div>超进化物语2剪纸联动</div>
                                </div>

                                <div class="game-item" style="cursor: pointer">
                                    <video src="../../assets/evolution.mp4" controls></video>

                                    <div>超进化物语主题曲</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!--<div class="part">-->
                    <!--<div class="part-title">-->
                    <!--<h3>{{contents[890]}}</h3>-->
                    <!--<span class="pull-right" style="margin-right: 10px">-->
                    <!--<router-link target="_blank" :to="'/card'" class="el-button&#45;&#45;text">{{contents[891]}}</router-link>-->
                    <!--</span>-->
                    <!--</div>-->
                    <!--<div class="part-body">-->
                    <!--<div class="game-list">-->
                    <!--<div class="game-item">-->
                    <!--<router-link target="_blank" :to="'/card/detail/1'">-->
                    <!--<img src="../../assets/img/gift1.png" alt="">-->
                    <!--</router-link>-->
                    <!--</div>-->
                    <!--<div class="game-item">-->
                    <!--<router-link target="_blank" :to="'/card/detail/1'">-->
                    <!--<img src="../../assets/img/gift2.png" alt="">-->
                    <!--</router-link>-->
                    <!--</div>-->
                    <!--<div class="game-item">-->
                    <!--<router-link target="_blank" :to="'/card/detail/1'">-->
                    <!--<img src="../../assets/img/gift3.png" alt="">-->
                    <!--</router-link>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="game-list">-->
                    <!--<div class="game-item">-->
                    <!--<router-link target="_blank" :to="'/card/detail/1'">-->
                    <!--<img src="../../assets/img/gift4.png" alt="">-->
                    <!--</router-link>-->
                    <!--</div>-->
                    <!--<div class="game-item">-->
                    <!--<router-link target="_blank" :to="'/card/detail/1'">-->
                    <!--<img src="../../assets/img/gift5.png" alt="">-->
                    <!--</router-link>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--</div>-->
                    <!--<div class="part">-->
                    <!--<div class="part-title">-->
                    <!--<h3>{{contents[892]}}</h3>-->
                    <!--<span class="pull-right" style="margin-right: 10px">-->
                    <!--<router-link target="_blank" :to="'/game'" class="el-button&#45;&#45;text">{{contents[893]}}</router-link>-->
                    <!--</span>-->
                    <!--</div>-->
                    <!--<div class="part-body">-->
                    <!--<div style="cursor: pointer" @click="toGame()"><img src="../../assets/img/900_200.png" alt="" width="885">-->
                    <!--</div>-->

                    <!--<div style="cursor: pointer;margin-top: 10px;" @click="toGame()"><img src="../../assets/img/900_200_1.png"-->
                    <!--alt="" width="885"></div>-->
                    <!--</div>-->
                    <!--</div>-->
                </div>
                <div class="part2-right fr">
                    <!--<div class="part">-->
                    <!--<div class="part-title">-->
                    <!--<h3>{{contents[894]}} <span style="opacity: .8"></span></h3>-->
                    <!--</div>-->
                    <!--<div class="part-body">-->
                    <!--<el-tabs v-model="activeName" @tab-click="">-->
                    <!--<el-tab-pane label="最新开服" name="first">-->
                    <!--<el-table-->
                    <!--:data="tableData"-->
                    <!--:show-header="false"-->
                    <!--@row-click="rowClick"-->
                    <!--style="width: 100%">-->
                    <!--<el-table-column-->
                    <!--prop="img"-->
                    <!--align="center"-->
                    <!--width="50">-->
                    <!--<template slot-scope="scope">-->
                    <!--<img style="width: 35px;height: 35px;border-radius: 5px"-->
                    <!--:src="scope.row.url" alt="">-->
                    <!--</template>-->
                    <!--</el-table-column>-->
                    <!--<el-table-column-->
                    <!--prop="time"-->
                    <!--label="日期"-->
                    <!--align="center">-->
                    <!--</el-table-column>-->
                    <!--<el-table-column-->
                    <!--prop="name"-->
                    <!--label="名称"-->
                    <!--align="center">-->
                    <!--</el-table-column>-->
                    <!--<el-table-column-->
                    <!--prop="status"-->
                    <!--label="状态"-->
                    <!--align="center"-->
                    <!--width="50">-->
                    <!--</el-table-column>-->
                    <!--</el-table>-->
                    <!--</el-tab-pane>-->
                    <!--<el-tab-pane label="开服预告" name="second">-->
                    <!--</el-tab-pane>-->
                    <!--</el-tabs>-->
                    <!--</div>-->
                    <!--</div>-->
                    <div class="part">
                        <div class="part-title">
                            <h3>{{contents[895]}} <span style="opacity: .8">{{contents[896]}}</span></h3>
                        </div>
                        <div class="part-body">
                            <el-tabs v-model="activeName2" @tab-click="">
                                <el-tab-pane label="热门攻略" name="first">
                                    <!--<el-table-->
                                        <!--:data="tableData2"-->
                                        <!--:show-header="false"-->
                                        <!--style="width: 100%">-->
                                        <!--<el-table-column>-->
                                            <!--<template slot-scope="scope">-->
                                                <!--<router-link-->
                                                    <!--style="width: 100%;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"-->
                                                    <!--:to=" '/article/' + scope.row.id">{{scope.row.text}}-->

                                                <!--</router-link>-->
                                            <!--</template>-->
                                        <!--</el-table-column>-->
                                    <!--</el-table>-->
                                    <!--<el-tab-pane label="平台公告" name="second">-->
                                        <!--<el-table-->
                                            <!--:data="tableData3"-->
                                            <!--:show-header="false"-->
                                            <!--style="width: 100%">-->
                                            <!--<el-table-column>-->
                                                <!--<template slot-scope="scope">-->
                                                    <!--<router-link-->
                                                        <!--style="width: 100%;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"-->
                                                        <!--:to=" '/article/' + scope.row.id">{{scope.row.text}}-->

                                                    <!--</router-link>-->
                                                <!--</template>-->
                                            <!--</el-table-column>-->
                                        <!--</el-table>-->
                                    <!--</el-tab-pane>-->
                                    <el-table
                                        :data="tableData4"
                                        :show-header="false"
                                        style="width: 100%">
                                        <el-table-column>
                                            <template slot-scope="scope">
                                                <router-link
                                                    style="width: 100%;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                                                    :to=" '/introduction/' + scope.row.id">{{scope.row.text}}

                                                </router-link>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-tab-pane>
                                <el-tab-pane label="最新公告" name="second">
                                    <el-table
                                        :data="tableData5"
                                        :show-header="false"
                                        style="width: 100%">
                                        <el-table-column>
                                            <template slot-scope="scope">
                                                <router-link
                                                    style="width: 100%;overflow: hidden;white-space: nowrap;text-overflow:ellipsis;"
                                                    :to=" '/notice/' + scope.row.id">{{scope.row.text}}

                                                </router-link>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!--<el-table-->
                                        <!--:data="tableData"-->
                                        <!--:show-header="false"-->
                                        <!--@row-click="rowClick"-->
                                        <!--style="width: 100%">-->
                                        <!--<el-table-column-->
                                            <!--prop="img"-->
                                            <!--align="center"-->
                                            <!--width="50">-->
                                            <!--<template slot-scope="scope">-->
                                                <!--<img style="width: 35px;height: 35px;border-radius: 5px"-->
                                                     <!--:src="scope.row.url" alt="">-->
                                            <!--</template>-->
                                        <!--</el-table-column>-->
                                        <!--<el-table-column-->
                                            <!--prop="time"-->
                                            <!--label="日期"-->
                                            <!--align="center">-->
                                        <!--</el-table-column>-->
                                        <!--<el-table-column-->
                                            <!--prop="name"-->
                                            <!--label="名称"-->
                                            <!--align="center">-->
                                        <!--</el-table-column>-->
                                        <!--<el-table-column-->
                                            <!--prop="status"-->
                                            <!--label="状态"-->
                                            <!--align="center"-->
                                            <!--width="50">-->
                                        <!--</el-table-column>-->
                                    <!--</el-table>-->
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                    <div style="width: 282px;height: 148px">
                        <router-link style="width: 100%" :to="'/jianhu'">
                            <img src="../../assets/img/jzjh.png" alt="">
                        </router-link>
                    </div>
                </div>
            </div>
            <div class="part part5">
                <div class="part-title">
                    <h3>{{contents[897]}}</h3>
                </div>
                <div class="part-body">
                    <ul class="game-ul-list">
                        <li>
                            <router-link :to="'/game/detail/12'" class="info">
                                <img src='../../assets/img/game/game12_icon.png' class="" alt="超进化物语"
                                     style="opacity: 1;">
                                <p>超进化物语</p>
                                <span class="radius90"></span>
                            </router-link>
                            <router-link :to="'/game/detail/12'" class="down">立即下载</router-link>
                        </li>
                        <li>
                            <router-link :to="'/game/detail/13'" class="info">
                                <img src='../../assets/img/game/game13_icon.png' class="" alt="超进化物语2"
                                     style="opacity: 1;">
                                <p>超进化物语2</p>
                                <span class="radius90"></span>
                            </router-link>
                            <router-link :to="'/game/detail/13'" class="down">立即下载</router-link>
                        </li>
                        <!--<li>-->
                        <!--<router-link :to="'/game/detail/12'" class="info">-->
                        <!--<img src="http://image.game.uc.cn/2018/5/4/20204352_.png" class="" alt="明日之后" style="opacity: 1;">-->
                        <!--<p>{{contents[898]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</router-link>-->
                        <!--<router-link :to="'/game/detail/12'" class="down">{{contents[899]}}</router-link>-->
                        <!--</li>-->

                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/dhsurvive/&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_833255_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_118114"&ndash;&gt;-->
                        <!--&lt;!&ndash;data-statis="text:logo_p_index_gds_176_118114" title="明日之后">&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/1'" class="info">-->
                        <!--<img src="http://image.game.uc.cn/2018/5/4/20204352_.png" class="" alt="明日之后" style="opacity: 1;">-->
                        <!--<p>{{contents[898]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</router-link>-->
                        <!--&lt;!&ndash;</a>&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_833255_2.html?ch=JY_123" rel="nofollow" target="_self"&ndash;&gt;-->
                        <!--&lt;!&ndash;class="down" name="uc_gd_adm" gd_stat="176_118114" data-statis="text:btn_p_index_gds_176_118114"&ndash;&gt;-->
                        <!--&lt;!&ndash;title="明日之后下载" data-us="0" data-gs="0">{{contents[899]}}</a>&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/1'" class="down">{{contents[899]}}</router-link>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/mengxiangqiyuan/&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_956473_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_118013"&ndash;&gt;-->
                        <!--&lt;!&ndash;data-statis="text:logo_p_index_gds_176_118013" title="萌宠大作战">&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/2'" class="info">-->
                        <!--<img src="http://image.game.uc.cn/2018/10/8/24763977_.png" class="" alt="萌宠大作战" style="opacity: 1;">-->
                        <!--<p>{{contents[900]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--&lt;!&ndash;</a>&ndash;&gt;-->
                        <!--</router-link>-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_956473_2.html?ch=JY_123" rel="nofollow" target="_self"&ndash;&gt;-->
                        <!--&lt;!&ndash;class="down" name="uc_gd_adm" gd_stat="176_118013" data-statis="text:btn_p_index_gds_176_118013"&ndash;&gt;-->
                        <!--&lt;!&ndash;title="萌宠大作战下载" data-us="0" data-gs="0">{{contents[901]}}</a>&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/2'" class="down">{{contents[901]}}</router-link>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/zjsjsjz/&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_748595_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_118012"&ndash;&gt;-->
                        <!--&lt;!&ndash;data-statis="text:logo_p_index_gds_176_118012" title="战舰世界">&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/3'" class="info">-->
                        <!--<img src="http://image.game.uc.cn/2018/10/17/25290045_.png" class="" alt="战舰世界" style="opacity: 1;">-->
                        <!--<p>{{contents[902]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</router-link>-->
                        <!--&lt;!&ndash;</a>&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_748595_2.html?ch=JY_123" rel="nofollow" target="_self"&ndash;&gt;-->
                        <!--&lt;!&ndash;class="down" name="uc_gd_adm" gd_stat="176_118012" data-statis="text:btn_p_index_gds_176_118012"&ndash;&gt;-->
                        <!--&lt;!&ndash;title="战舰世界闪击战下载" data-us="0" data-gs="0">{{contents[903]}}</a>&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/3'" class="down">{{contents[903]}}</router-link>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/hhwrsyz/&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_868747_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_115412"&ndash;&gt;-->
                        <!--&lt;!&ndash;data-statis="text:logo_p_index_gds_176_115412" title="航海王:燃烧意志">&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/4'" class="info">-->
                        <!--<img src="http://image.game.uc.cn/2018/10/17/25285342_.png" class="" alt="航海王:燃烧意志" style="opacity: 1;">-->
                        <!--<p>{{contents[904]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</router-link>-->
                        <!--&lt;!&ndash;</a>&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_868747_2.html?ch=JY_123" rel="nofollow" target="_self"&ndash;&gt;-->
                        <!--&lt;!&ndash;class="down" name="uc_gd_adm" gd_stat="176_115412" data-statis="text:btn_p_index_gds_176_115412"&ndash;&gt;-->
                        <!--&lt;!&ndash;title="航海王：燃烧意志下载" data-us="0" data-gs="0">{{contents[905]}}</a>&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/4'" class="down">{{contents[905]}}</router-link>-->
                        <!--</li>-->
                        <!--<li class="last">-->
                        <!--&lt;!&ndash;http://www.9game.cn/taoyuanxianjing/&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_858964_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_117676"&ndash;&gt;-->
                        <!--&lt;!&ndash;data-statis="text:logo_p_index_gds_176_117676" title="桃源仙境">&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/5'" class="info">-->
                        <!--<img src="http://image.game.uc.cn/2018/10/12/25059708_.png" class="" alt="桃源仙境" style="opacity: 1;">-->
                        <!--<p>{{contents[906]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</router-link>-->
                        <!--&lt;!&ndash;</a>&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_858964_2.html?ch=JY_123" rel="nofollow" target="_self"&ndash;&gt;-->
                        <!--&lt;!&ndash;class="down" name="uc_gd_adm" gd_stat="176_117676" data-statis="text:btn_p_index_gds_176_117676"&ndash;&gt;-->
                        <!--&lt;!&ndash;title="桃源仙境下载" data-us="0" data-gs="0">{{contents[907]}}</a>&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/5'" class="down">{{contents[907]}}</router-link>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/tkkn/&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_964625_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_117677"&ndash;&gt;-->
                        <!--&lt;!&ndash;data-statis="text:logo_p_index_gds_176_117677" title="红警OL">&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/6'" class="info">-->
                        <!--<img src="http://image.game.uc.cn/2018/9/30/24145729_.png" class="" alt="红警OL" style="opacity: 1;">-->
                        <!--<p>{{contents[908]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</router-link>-->
                        <!--&lt;!&ndash;</a>&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_964625_2.html?ch=JY_123" rel="nofollow" target="_self"&ndash;&gt;-->
                        <!--&lt;!&ndash;class="down" name="uc_gd_adm" gd_stat="176_117677" data-statis="text:btn_p_index_gds_176_117677"&ndash;&gt;-->
                        <!--&lt;!&ndash;title="红警OL下载" data-us="0" data-gs="0">{{contents[909]}}</a>&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/6'" class="down">{{contents[909]}}</router-link>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/sdyxl/&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_828511_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_116727"&ndash;&gt;-->
                        <!--&lt;!&ndash;data-statis="text:logo_p_index_gds_176_116727" title="神都夜行录">&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/10'" class="info">-->
                        <!--<img src="http://image.game.uc.cn/2018/9/25/23713429_.jpg" class="" alt="神都夜行录" style="opacity: 1;">-->
                        <!--<p>{{contents[910]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</router-link>-->
                        <!--&lt;!&ndash;</a>&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_828511_2.html?ch=JY_123" rel="nofollow" target="_self"&ndash;&gt;-->
                        <!--&lt;!&ndash;class="down" name="uc_gd_adm" gd_stat="176_116727" data-statis="text:btn_p_index_gds_176_116727"&ndash;&gt;-->
                        <!--&lt;!&ndash;title="神都夜行录下载" data-us="0" data-gs="0">{{contents[911]}}</a>&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/10'" class="down">{{contents[911]}}</router-link>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/csmqs/&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_812121_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_117678"&ndash;&gt;-->
                        <!--&lt;!&ndash;data-statis="text:logo_p_index_gds_176_117678" title="传送门骑士">&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/11'" class="info">-->
                        <!--<img src="http://image.game.uc.cn/2018/6/27/20722521_.png" class="" alt="传送门骑士" style="opacity: 1;">-->
                        <!--<p>{{contents[912]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</router-link>-->
                        <!--&lt;!&ndash;</a>&ndash;&gt;-->
                        <!--&lt;!&ndash;<a href="http://www.9game.cn/game/downs_812121_2.html?ch=JY_123" rel="nofollow" target="_self"&ndash;&gt;-->
                        <!--&lt;!&ndash;class="down" name="uc_gd_adm" gd_stat="176_117678" data-statis="text:btn_p_index_gds_176_117678"&ndash;&gt;-->
                        <!--&lt;!&ndash;title="传送门骑士下载" data-us="0" data-gs="0">{{contents[913]}}</a>&ndash;&gt;-->
                        <!--<router-link :to="'/game/detail/11'" class="down">{{contents[913]}}</router-link>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/xbxxz/&ndash;&gt;-->
                        <!--<a href="http://www.9game.cn/game/downs_988303_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_116726"-->
                        <!--data-statis="text:logo_p_index_gds_176_116726" title="想不想修真">-->
                        <!--<img src="http://image.game.uc.cn/2018/8/20/21706200_.png" class="" alt="想不想修真" style="opacity: 1;">-->
                        <!--<p>{{contents[914]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</a>-->
                        <!--<a href="http://www.9game.cn/game/downs_988303_2.html?ch=JY_123" rel="nofollow" target="_self"-->
                        <!--class="down" name="uc_gd_adm" gd_stat="176_116726" data-statis="text:btn_p_index_gds_176_116726"-->
                        <!--title="想不想修真下载" data-us="0" data-gs="0">{{contents[915]}}</a>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/wdqk/&ndash;&gt;-->
                        <!--<a href="http://www.9game.cn/game/downs_855845_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_113047"-->
                        <!--data-statis="text:logo_p_index_gds_176_113047" title="武动乾坤">-->
                        <!--<img src="http://image.game.uc.cn/2018/10/29/28252944_.png" class="" alt="武动乾坤" style="opacity: 1;">-->
                        <!--<p>{{contents[916]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</a>-->
                        <!--<a href="http://www.9game.cn/game/downs_855845_2.html?ch=JY_123" rel="nofollow" target="_self"-->
                        <!--class="down" name="uc_gd_adm" gd_stat="176_113047" data-statis="text:btn_p_index_gds_176_113047"-->
                        <!--title="武动乾坤（正版手游）下载" data-us="0" data-gs="0">{{contents[917]}}</a>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/dwrg/&ndash;&gt;-->
                        <!--<a href="http://www.9game.cn/game/downs_800051_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_104105"-->
                        <!--data-statis="text:logo_p_index_gds_176_104105" title="第五人格">-->
                        <!--<img src="http://image.game.uc.cn/2018/8/30/21989772_.png" class="" alt="第五人格" style="opacity: 1;">-->
                        <!--<p>{{contents[918]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</a>-->
                        <!--<a href="http://www.9game.cn/game/downs_800051_2.html?ch=JY_123" rel="nofollow" target="_self"-->
                        <!--class="down" name="uc_gd_adm" gd_stat="176_104105" data-statis="text:btn_p_index_gds_176_104105"-->
                        <!--title="第五人格下载" data-us="0" data-gs="0">{{contents[919]}}</a>-->
                        <!--</li>-->
                        <!--<li>-->
                        <!--&lt;!&ndash;http://www.9game.cn/mhmnz/&ndash;&gt;-->
                        <!--<a href="http://www.9game.cn/game/downs_761002_2.html?ch=JY_123" class="info" name="uc_gd_adm" gd_stat="176_113053"-->
                        <!--data-statis="text:logo_p_index_gds_176_113053" title="梦幻模拟战">-->
                        <!--<img src="http://image.game.uc.cn/2018/10/11/24997191_.png" class="" alt="梦幻模拟战" style="opacity: 1;">-->
                        <!--<p>{{contents[920]}}</p>-->
                        <!--<span class="radius90"></span>-->
                        <!--</a>-->
                        <!--<a href="http://www.9game.cn/game/downs_761002_2.html?ch=JY_123" rel="nofollow" target="_self"-->
                        <!--class="down" name="uc_gd_adm" gd_stat="176_113053" data-statis="text:btn_p_index_gds_176_113053"-->
                        <!--title="梦幻模拟战下载" data-us="0" data-gs="0">{{contents[921]}}</a>-->
                        <!--</li>-->
                    </ul>
                </div>
            </div>
            <!--<div class="part part5">
                <div class="part-title">
                    <h3>合作厂商</h3>
                </div>
                <div class="part-body">
                    <div class="company-item">
                      &lt;!&ndash;http://www.4399.com/&ndash;&gt;
                        <a target="_blank" href="">
                            <img src="../../assets/img/company1.png" alt="">
                        </a>
                    </div>
                    <div class="company-item">
                      &lt;!&ndash;https://www.17173.com/&ndash;&gt;
                        <a target="_blank" href="">
                            <img src="../../assets/img/company2.png" alt="">
                        </a>
                    </div>
                    <div class="company-item">
                      &lt;!&ndash;http://www.9game.cn/&ndash;&gt;
                        <a target="_blank" href="">
                            <img src="../../assets/img/company3.png" alt="">
                        </a>
                    </div>
                </div>
            </div>-->
        </div>
    </div>
</template>

<script>
    import httpRequest from '../../service/http_request';

    const icp = require('../../lib/icp');
    const Utils = require('../../lib/utils');
    export default {
        data() {
            return {
                imgList: [{
                    pictureUrl: require('../../assets/img/banner/banner1.png'),
                    id: 12
                }, {
                    pictureUrl: require('../../assets/img/banner/banner2.png'),
                    id: 13
                }],
                // imgList: [{
                //     pictureUrl: require('../../assets/img/carousel1.png')
                // }, {
                //     pictureUrl: require('../../assets/img/carousel2.png')
                // }, {
                //     pictureUrl: require('../../assets/img/carousel3.png')
                // }, {
                //     pictureUrl: require('../../assets/img/carousel4.png')
                // }],
                showLogin: true,
                account: '',
                headerimg: require('../../assets/headerimg/1.png'),
                tableData: [{
                    url: require('../../assets/img/icon.png'),
                    time: '04/28 09:00',
                    name: '超进化物语',
                    status: '测试'
                }, {
                    url: require('../../assets/img/icon.png'),
                    time: '04/28 09:00',
                    name: '超进化物语',
                    status: '测试'
                }, {
                    url: require('../../assets/img/icon.png'),
                    time: '04/28 09:00',
                    name: '超进化物语',
                    status: '测试'
                }, {
                    url: require('../../assets/img/icon.png'),
                    time: '04/28 09:00',
                    name: '超进化物语',
                    status: '测试'
                }, {
                    url: require('../../assets/img/icon.png'),
                    time: '04/28 09:00',
                    name: '超进化物语',
                    status: '测试'
                }, {
                    url: require('../../assets/img/icon.png'),
                    time: '04/28 09:00',
                    name: '超进化物语',
                    status: '测试'
                }],
                tableData2: [{
                    id: 10,
                    text: '乌镇互联网大会今召开'
                }, {
                    id: 11,
                    text: '揽入近135亿元游戏资产 世纪华通(002602)夯实双主业 '
                }, {
                    id: 12,
                    text: 'F2P游戏的玩家管理系统到底有多重要'
                }, {
                    id: 13,
                    text: '中国游戏企业高峰论坛圆桌沙龙谈GAME+'
                }, {
                    id: 14,
                    text: '一张图读懂：32家游戏上市公司的Q3业绩表现'
                }, /*{
                 id: 15,
                 text: '中清龙图公告:资产重组停止不影响游戏业务'
                 }, {
                 id: 16,
                 text: '精彩暂别，品质依旧，“好电视好游戏”TCL站告捷'
                 }, {
                 id: 17,
                 text: '看着并不冷 盘点拥有绝美雪景的经典游戏'
                 }, {
                 id: 18,
                 text: '虚拟照进现实 游戏博览会VR高峰论坛'
                 }, {
                 id: 19,
                 text: '国产佳作角逐第七届中国优秀游戏制作人大赛'
                 }*/],
                tableData3: [{
                    id: 23,
                    text: 'VIP成长介绍...'
                }, {
                    id: 24,
                    text: '游戏趣图征集活动火热进行中...'
                }],
                activeName: 'first',
                activeName2: 'first',
                loginData: {
                    loginName: '',
                    pwd: ''
                },
                rememberPassword: false,
                // rules
                loginRules: {
                    loginName: [
                        {required: true, message: '请输入用户名', trigger: 'blur'},
                        {min: 6, max: 15, message: '长度在 6 到 15 个字符之间', trigger: 'blur'}
                    ],
                    pwd: [
                        {required: true, message: '请输入密码', trigger: 'blur'}
                    ]
                },
                contents: '',
                tableData4: [{
                    id: 1,
                    text: '综合攻略丨如虎添翼《超进化物语》觉醒功能解读'
                }, {
                    id: 2,
                    text: '综合攻略丨体力续航秘笈'
                }, {
                    id: 3,
                    text: '综合攻略丨关于物种同化，你能做的还有这些'
                }, {
                    id: 4,
                    text: '综合攻略丨浅谈大基因节点的作用'
                }, {
                    id: 5,
                    text: '套路盘点 |《超进化物语》关于送死流阵容的思考'
                }, {
                    id: 6,
                    text: '套路盘点 |《超进化物语》关于真实伤害阵容的思考'
                }, {
                    id: 7,
                    text: '玩家攻略 | 有颜有料，超魅妆全接触'
                }, {
                    id: 8,
                    text: '玩家攻略 | 最终兵器基因密码大破解'
                }],
                tableData5: [{
                    id: 1,
                    text: '「1.8海鸣起」版本活动调整公告'
                }, {
                    id: 2,
                    text: '「1.8海鸣起」版本即将更新，迎接来自新位面的挑战吧'
                }, {
                    id: 3,
                    text: '「1.8海鸣起」版本活动大爆料'
                }, {
                    id: 4,
                    text: '1.7版本更新内容、福利盘点，优化调整持续进行中'
                }, {
                    id: 5,
                    text: '「1.7启程季」版本前瞻，绯色渴望，悸动启程！'
                }, {
                    id: 6,
                    text: '1.6版本福利和更新内容盘点，新一波平衡性调整将至！'
                }, {
                    id: 7,
                    text: '《超进化物语2》手游系统概率公示'
                }],
            }
        },
        created() {
            this.addLog();
            this.getContent();
            if (Utils.getCookie('token') != undefined) {
                this.account = Utils.getCookie('account');
                this.headerimg = require("../../assets/headerimg/" + Utils.getCookie('headerimg') + ".png");
                this.showLogin = false;

            }
        },
        mounted() {

        },
        methods: {
            //页面日志
            addLog() {
                httpRequest.request(
                    'post',
                    icp.urls.page_addLog, {
                        params: {
                            action: '打开首页界面',
                            actionUrl: '/home',
                            actionContent: '打开首页界面'
                        }
                    }, function (res) {

                    })
            },
            // 提交登录
            login(formName) {
                var self = this;
                self.$refs[formName].validate((valid) => {
                    if (valid) {
                        httpRequest.request(
                            'post',
                            icp.urls.account_login, {
                                account: self.loginData.loginName,
                                password: self.loginData.pwd
                            }, function (res) {
                                if (res != null) {
                                    Utils.setCookie('account', res.account);
                                    Utils.setCookie('headerimg', res.headerimg);
                                    Utils.setCookie('token', res.token);
                                    self.$router.push('/loginSuccess');
                                }
                            })
                    } else {
                        self.$message({
                            message: '请填写用户名跟密码',
                            type: 'warning'
                        });
                        return false;
                    }
                });
            },

            //退出
            loginOut() {
                this.addLoginOutLog();
                Utils.delCookie('token');
                Utils.delCookie('account');
                Utils.delCookie('headerimg');
                this.$store.commit("updateUserInfo", '');//更新登录状态
                this.$router.push({
                    path: '/loginOut'
                });
            },
            //页面日志
            addLoginOutLog() {
                httpRequest.request(
                    'post',
                    icp.urls.page_addLog, {
                        params: {
                            action: '退出',
                            actionUrl: '/loginOut',
                            actionContent: '用户退出'
                        }
                    }, function (res) {

                    })
            },

            toGame() {
                var self = this;
                if (Utils.getCookie('token') == undefined) {
                    self.$message({
                        message: '请先登录',
                        type: 'warning'
                    });
                } else {

                    //关闭外链
                    self.$message({
                        message: '游戏维护中',
                        type: 'warning'
                    });

                    //var account = Utils.getCookie('account');
                    //window.open("http://game.ntfusion.com/?email=" + account);
                }
            },

            rowClick(row, event, column) {
                // var self = this;
                // if (Utils.getCookie('token') == undefined) {
                //     self.$message({
                //         message: '请先登录',
                //         type: 'warning'
                //     });
                // } else {
                //     var account = Utils.getCookie('account');
                //     window.open("http://game.ntfusion.com/?email=" + account);
                // }
                window.open('http://game.ntfusion.com/')
            },
            getContent() {
                var self = this;
                httpRequest.request(
                    'post',
                    icp.urls.page_getContents, {
                        params: {
                            page: 11
                        }
                    }, function (res) {
                        self.contents = res;
                    })
            }
        }
    }
</script>
<style lang="less">
    #home-page {
        .el-carousel {
            img {
                width: 100%;
                /*height: 400px;*/
            }

        }

        .loginBg {
            position: relative;

            .loginCenter {
                position: absolute;
                padding: 20px;
                top: 20px;
                left: 50%;
                margin-left: -600px;
                width: 260px;
                height: 290px;
                z-index: 9;
                filter: alpha(opacity=50);
                -moz-opacity: 0.5;
                -khtml-opacity: 0.5;
                border-radius: 15px;
                overflow: hidden;

                .loginArea {
                    position: absolute;
                    padding: 20px;
                    width: 260px;
                    height: 290px;
                    top: 0;
                    left: 0;
                    background: #FFF;
                    opacity: 0.8;
                }

                .el-form {
                    position: absolute;
                    padding: 20px;
                    width: 260px;
                    height: 290px;
                    top: 0;
                    left: 0;
                    background: transparent;

                    h3 {
                        margin-bottom: 10px;
                    }
                }

                .user {
                    position: absolute;
                    padding: 20px;
                    width: 260px;
                    height: 290px;
                    top: 0;
                    left: 0;
                    background: transparent;

                    .userLogo {
                        margin-top: 10px;
                        padding-right: 10px;
                        width: 90px;
                        height: 90px;
                        float: left;

                        img {
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }

                    p {
                        margin-bottom: 10px;
                    }

                    a + a {
                        margin-left: 10px;
                    }

                    h4 {
                        height: 35px;
                        line-height: 35px;
                        font-weight: bold;
                    }

                    .user-bottom {
                        border-bottom: 1px solid #33b874;
                        padding: 10px 0;
                        text-align: center;

                        a:hover {
                            text-decoration: underline;
                        }
                    }
                }
            }
        }

        .content {
            background-color: #ffffff;
            overflow: hidden;

            .part {
                .part-title {
                    h3 {
                        display: inline-block;
                    }

                    span {
                        font-size: 13px;
                    }
                }

                .part-body {
                    margin-top: 15px;

                    .el-row {
                        display: inline-block;

                        .task-box {
                            display: inline-block;
                            margin: 0;
                            padding: 10px;
                            text-align: center;
                            border: 1px solid #dddddd;
                            background-color: #ffffff;
                            vertical-align: top;

                            img {
                                display: inline-block;
                                width: 200px;
                                height: 125px;
                            }

                            h4 {
                                margin-top: 20px;
                                color: #000;
                                line-height: 20px;
                                font-size: 17px;
                            }

                            p {
                                color: #000;
                                line-height: 20px;
                                font-size: 12px;
                                margin: 10px 0;
                            }
                        }

                        .task-box.packet {
                            padding: 0;
                            border: none;
                            background-color: transparent;

                            img {
                                width: 222px;
                                height: 260px;
                            }
                        }

                        .plus-icon {
                            display: inline-block;

                            img {
                                display: inline-block;
                                margin: 115px 15px;
                            }
                        }
                    }
                }

                ul.part-nav {
                    li {
                        display: inline-block;
                        padding: 0 5px;
                    }

                    li + li {
                        border-left: 2px solid #ccc;
                    }
                }

                .income-content-detail {
                    display: block;
                    height: 200px;
                    overflow: scroll;
                    overflow-y: hidden;
                    text-align: left;

                    .income-item {
                        .el-row {
                            width: 100%;
                        }
                    }
                }
            }

            .part2 {
                .part2-left {
                    display: inline-block;
                    margin-top: 10px;
                    width: 900px;

                    .part-body {
                        h4 {
                            margin: 10px 0;
                        }

                        .game-list {
                            .game-item {
                                display: inline-block;

                                img {
                                    /*width: 286px;*/
                                    /*height: 143px;*/
                                    width: 240px;
                                    height: 160px;
                                }

                                video {
                                    width: 240px;
                                }

                                div {
                                    text-align: center;
                                }
                            }

                            .game-item + .game-item {
                                margin-left: 10px;
                            }
                        }

                        .game-list + .game-list {
                            margin-top: 10px;
                        }
                    }
                }

                .part2-right {
                    vertical-align: top;
                    width: 300px;
                    overflow: hidden;
                    float: right;

                    .part {
                        min-height: 300px;

                        .part-title {
                            margin: 10px 0;
                            padding: 10px 20px 10px 0;

                            h3 {
                                display: inline-block;
                            }
                        }
                    }
                }
            }

            .part3 {
                margin-top: 10px;

                .part-body {
                    background-color: #ffffff;

                    .el-tabs__header {
                        .el-tabs__nav-wrap {
                            padding: 0;

                            .el-tabs__nav-prev {
                                display: none;
                            }

                            .el-tabs__nav-next {
                                display: none;
                            }

                            .el-tabs__nav {
                                width: 100%;

                                .el-tabs__item {
                                    width: 20%;
                                    height: 100px;

                                    .icon-red {
                                        position: relative;
                                        text-align: center;
                                        border-radius: 4px;
                                        margin: 25px 0;

                                        span {
                                            position: absolute;
                                            top: 15px;
                                            left: 75px;
                                            color: #fcec54;
                                            font-size: 18px;
                                        }
                                    }
                                }

                            }
                        }
                    }

                    .el-tabs__content {
                        text-align: center;

                        .el-row {
                            margin: 0 auto;

                            h3 {
                                text-align: left;
                                color: #949494;
                                margin-bottom: 5px;
                            }

                            .favorite-list {
                                .favorite-item {
                                    display: inline-block;
                                    padding: 10px;
                                    border-left: 1px solid #dadada;
                                    background-color: #f4f5f9;
                                    white-space: nowrap;

                                    p {

                                    }
                                }
                            }

                            .tip {
                                color: #666;
                                text-align: center;
                                line-height: 63px;
                            }
                        }
                    }
                }

            }

            .part5 {
                .part-body {
                    border-bottom: 1px #cecece solid;
                    border-top: 1px #cecece solid;

                    .company-item {
                        display: inline-block;

                        img {
                            width: 177px;
                            height: 77px;
                        }
                    }

                    .company-item + .company-item {
                        margin-left: 10px;
                    }
                }
            }

        }
    }

    .game-ul-list li {
        padding: 10px;
        width: 90px;
        float: left;
        margin: 0 10px 5px 0;
    }

    .game-ul-list li .info {
        display: block;
        width: 90px;
        position: relative;
        cursor: pointer;
    }

    .game-ul-list li .info img {
        width: 90px;
        height: 90px;
        display: block;
    }

    .game-ul-list li .info p {
        width: 90px;
        font-size: 14px;
        line-height: 28px;
        text-align: center;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }

    .radius90 {
        width: 90px;
        height: 90px;
        display: block;
        background: url(http://portal.ucgc.ucfly.com/public/images/pc/pc_new/img_radius.png) no-repeat 0 0;
        _background: url(http://portal.ucgc.ucfly.com/public/images/pc/pc_new/img_radius.gif) no-repeat 0 0;
        background-repeat: no-repeat;
        position: absolute;
        top: 0;
        left: 0;
    }

    .game-ul-list li a.down {
        display: block;
        width: 66px;
        height: 23px;
        border: 1px solid #ccc;
        -moz-border-radius: 4px;
        -khtml-border-radius: 4px;
        -webkit-border-radius: 4px;
        border-radius: 4px;
        margin: 0 auto;
        text-align: center;
        line-height: 23px;
        background: #fafafa;
        background: -moz-linear-gradient(top, #fff, #fafafa);
        background: -webkit-linear-gradient(top, #fff, #fafafa);
        background: -ms-linear-gradient(top, #fff, #fafafa);
        background: -o-linear-gradient(top, #fff, #fafafa);
    }

    .game-con-5 .game-ul-list li.last {
        margin: 0 0 5px 0;
    }
</style>



// WEBPACK FOOTER //
// src/view/home/home.vue